import { render } from "./TopNavLink.vue?vue&type=template&id=bed015e6"
import script from "./TopNavLink.vue?vue&type=script&lang=js"
export * from "./TopNavLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TopNavLink.vue"]])

export default __exports__